"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPanelSection;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

function UIPanelSection(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_UISection.default, Object.assign({}, rest, {
    className: (0, _classnames.default)(className, 'private-panel__section')
  }));
}

UIPanelSection.propTypes = Object.assign({}, _UISection.default.propTypes, {
  children: _propTypes.default.node
});
UIPanelSection.defaultProps = Object.assign({}, _UISection.default.defaultProps);
UIPanelSection.displayName = 'UIPanelSection';
module.exports = exports.default;